import { calculateLocatinVars } from '../../../libs/browser';
import { formatDate } from '../../../libs/date';
import { parseError } from '../../../libs/parser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackCloseBarComponent from '../../../components/BackCloseBarComponent';
import CommonDescription from '../../../components/CommonDescription';
import Context from '../../../provider';
import React, { useContext, useEffect, useRef, useState } from 'react';
import memberApi from '../../../libs/api/memberApi';
import useIsScrolling from '../../../hooks/useIsScrolling';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function MobileNewDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const locationVars = calculateLocatinVars(location.pathname);

  const notificationNotReadCount = useNotificationsCount();
  const [data, setData] = useState({});

  const scrollRef = useRef();
  const isScrolling = useIsScrolling(scrollRef.current);

  const { init, dispatch, me, lang } = useContext(Context);

  const fetchData = async () => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const page = await memberApi.getNewsDetail({ id: location.state?.id || locationVars[1] });
      setData(page.data);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  // This page only allow logged in user
  useEffect(() => {
    console.log('Mobile New Detail page', location, locationVars);
    if (init) {
      fetchData();
    }
    window.scrollTo(0, 0);
  }, [init, me, navigate]);

  return (
    (
      <div className='mobile-new-detail-page'>
        <BackCloseBarComponent />
        <div ref={scrollRef} className="content-container">
          { data && data.cover &&
            <div className="img-container">
              <img className="title-img" alt={data.title[lang]} src={ data.cover[lang] }/>
            </div>
          }
          <div className="news-content-container">
            <div className="news-title-time">
              { data && data.title &&
                <div className="title-text">
                  {data.title[lang]}
                </div>
              }
              { data && data.updated_at &&
                <div className="time-text">
                  {`${t('newsDetail.publishData')}: ${formatDate(data.updated_at, lang)}`}
                </div>
              }
            </div>
            { data && data.content &&
              <div className="news-content">
                <CommonDescription data={data?.content?.[lang]} />
              </div>
            }
          </div>
          <div style={{ height: '10rem' }} />
        </div>
      </div>
    )
  );
}